exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown[data-v-28b7e0eb] {\n  opacity: 0;\n  transition: opacity 0.2s;\n  position: absolute;\n  top: 100%;\n  right: 0;\n  pointer-events: none;\n}\n.dropdown .dropdown-inner[data-v-28b7e0eb] {\n  border-radius: 2px;\n  background-color: #ffffff;\n  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.08);\n  min-width: 300px;\n  display: flex;\n  flex-direction: column;\n}\n.dropdown.active[data-v-28b7e0eb] {\n  opacity: 1;\n  pointer-events: all;\n}\n.dropdown.active[data-v-28b7e0eb]:after {\n  opacity: 1;\n}", ""]);

// exports
